import React from 'react';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {FILE_EXTENSIONS, FILE_TYPES, MAX_FILE_SIZE} from 'constants/file/fileTypes';
import {ChangeResultType, Uploader} from 'desktop/components/helpers/uploader/uploader';

import {FileSpeciesType} from 'types/successPage';

import s from './successUpload.scss';

export type PropsType = {
    name: string;
    handleChange: (data: ChangeResultType) => void;
    fileSrc: string;
    fileName: string;
    fileType: FileSpeciesType;
};

/**
 * This component has only success upload file, it means when customer uploads file he or she will see this component
 * @param {PropsType} props - component props
 * @constructor
 */
export const SuccessUpload: React.FC<PropsType> = ({
    fileName,
    fileSrc,
    fileType,
    handleChange,
    name,
}) => {
    const fileTypeValue = (FILE_EXTENSIONS as Record<FileSpeciesType, string>)[fileType] || '';

    return (
        <div className={s.successWrapper}>
            {fileTypeValue ? (
                <div className={s.textIconContainer} role="presentation">
                    <CloudinaryImage
                        alt="document icon"
                        className={s.documentIcon}
                        src="./images/icon.svg"
                    />
                    <span className={s.textIcon}>{fileTypeValue}</span>
                </div>
            ) : (
                // disabled cloudinary because of it uploaded file from customer
                // eslint-disable-next-line react/forbid-elements
                <img alt={name} className={s.uploadedFile} src={fileSrc} />
            )}
            <div className={s.description}>
                <p className={s.successTitle}>Prescription uploaded successfully!</p>
                <p className={s.successFileName}>{fileName}</p>
                <div className={s.upload}>
                    <Uploader
                        fileTypes={FILE_TYPES}
                        handleChange={handleChange}
                        id="uploadFile"
                        maxSize={MAX_FILE_SIZE}
                    >
                        <div className={s.retake}>Reupload</div>
                    </Uploader>
                </div>
            </div>
        </div>
    );
};
